import { render, staticRenderFns } from "./SignInFast.vue?vue&type=template&id=6baf59ca"
import script from "./SignInFast.vue?vue&type=script&lang=js"
export * from "./SignInFast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports